// src/components/DashboardContent.js
import {
  Box, Text, Grid, GridItem, Heading, Image, Flex, Button,
  Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, ModalCloseButton,
  useDisclosure, Icon, Badge, SimpleGrid, Stat, StatLabel, StatNumber,
  StatHelpText, Table, Thead, Tbody, Tr, Th, Td, TableContainer,
  Progress, VStack, HStack, Divider, useColorModeValue
} from "@chakra-ui/react";
import { useState, useEffect } from "react";
import { jwtDecode } from "jwt-decode";
import { toStorageImageApiSegment } from "../utils/storageImagePath";
import { getSessionPermissions } from "../utils/auth";
import {
  FiTrendingUp, FiUsers, FiActivity, FiEye, FiTarget, FiAward,
  FiBarChart2, FiClock, FiCamera, FiCpu, FiAlertTriangle
} from "react-icons/fi";

// Ícones de tempo existentes...
const SunIcon = (props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      d="M12,7A5,5 0 0,0 7,12A5,5 0 0,0 12,17A5,5 0 0,0 17,12A5,5 0 0,0 12,7M12,9A3,3 0 0,1 15,12A3,3 0 0,1 12,15A3,3 0 0,1 9,12A3,3 0 0,1 12,9M12,2L14.39,5.42C13.65,5.15 12.84,5 12,5C11.16,5 10.35,5.15 9.61,5.42L12,2M3.34,7L7.5,6.65C6.9,7.16 6.36,7.78 5.94,8.5C5.5,9.24 5.25,10 5.11,10.79L3.34,7M3.36,17L5.12,13.23C5.26,14 5.53,14.78 5.95,15.5C6.37,16.24 6.91,16.86 7.5,17.37L3.36,17M20.65,7L18.88,10.79C18.74,10 18.47,9.23 18.05,8.5C17.63,7.78 17.1,7.15 16.5,6.64L20.65,7M20.64,17L16.5,17.36C17.09,16.85 17.62,16.22 18.04,15.5C18.46,14.77 18.73,14 18.87,13.21L20.64,17M12,22L9.59,18.56C10.33,18.83 11.14,19 12,19C12.82,19 13.63,18.83 14.37,18.56L12,22Z"
    />
  </Icon>
);

const MoonIcon = (props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      d="M17.75,4.09L15.22,6.03L16.13,9.09L13.5,7.28L10.87,9.09L11.78,6.03L9.25,4.09L12.44,4L13.5,1L14.56,4L17.75,4.09M21.25,11L19.61,12.25L20.2,14.23L18.5,13.06L16.8,14.23L17.39,12.25L15.75,11L17.81,10.95L18.5,9L19.19,10.95L21.25,11M18.97,15.95C19.8,15.87 20.69,17.05 20.16,17.8C19.84,18.25 19.5,18.67 19.08,19.07C15.17,23 8.84,23 4.94,19.07C1.03,15.17 1.03,8.83 4.94,4.93C5.34,4.53 5.76,4.17 6.21,3.85C6.96,3.32 8.14,4.21 8.06,5.04C7.79,7.9 8.75,10.87 10.95,13.06C13.14,15.26 16.1,16.22 18.97,15.95M17.33,17.97C14.5,17.81 11.7,16.64 9.53,14.5C7.36,12.31 6.2,9.5 6.04,6.68C3.23,9.82 3.34,14.64 6.35,17.66C9.37,20.67 14.19,20.78 17.33,17.97Z"
    />
  </Icon>
);

const SunsetIcon = (props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      d="M3,12H7A5,5 0 0,1 12,7A5,5 0 0,1 17,12H21A1,1 0 0,1 22,13A1,1 0 0,1 21,14H3A1,1 0 0,1 2,13A1,1 0 0,1 3,12M15,12A3,3 0 0,0 12,9A3,3 0 0,0 9,12H15M12,2L14.39,5.42C13.65,5.15 12.84,5 12,5C11.16,5 10.35,5.15 9.61,5.42L12,2M3.34,7L7.5,6.65C6.9,7.16 6.36,7.78 5.94,8.5C5.5,9.24 5.25,10 5.11,10.79L3.34,7M20.65,7L18.88,10.79C18.74,10 18.47,9.23 18.05,8.5C17.63,7.78 17.1,7.15 16.5,6.64L20.65,7M12.71,16.3L15.82,19.41C16.21,19.8 16.21,20.43 15.82,20.82C15.43,21.21 14.8,21.21 14.41,20.82L12,18.41L9.59,20.82C9.2,21.21 8.57,21.21 8.18,20.82C7.79,20.43 7.79,19.8 8.18,19.41L11.29,16.3C11.5,16.1 11.74,16 12,16C12.26,16 12.5,16.1 12.71,16.3Z"
    />
  </Icon>
);

// Componente para card de ranking
const RankingCard = ({ title, data, icon, colorScheme, field, label }) => {
  const bgColor = useColorModeValue("white", "gray.800");

  return (
    <Box bg={bgColor} p={6} borderRadius="lg" boxShadow="md" h="full">
      <HStack mb={4} spacing={3}>
        <Icon as={icon} boxSize="24px" color={`${colorScheme}.500`} />
        <Heading size="md" color={`${colorScheme}.600`}>{title}</Heading>
      </HStack>

      <VStack
        spacing={3}
        align="stretch"
        maxH="500px" // Aumentado de 400px para 500px
        minH="420px" // Altura mínima para garantir espaço para 7 usuários
        overflowY="auto"
        pr={2} // Adiciona padding à direita para dar espaço à scrollbar
        css={{
          '&::-webkit-scrollbar': {
            width: '8px',
          },
          '&::-webkit-scrollbar-track': {
            width: '8px',
            background: '#f1f1f1',
            borderRadius: '4px',
          },
          '&::-webkit-scrollbar-thumb': {
            background: '#c1c1c1',
            borderRadius: '4px',
          },
          '&::-webkit-scrollbar-thumb:hover': {
            background: '#a8a8a8',
          },
        }}
      >
        {data && data.length > 0 ? data.slice(0, 10).map((user, index) => (
          <Box key={user.id}>
            <Flex justify="space-between" align="center" py={2}>
              <HStack spacing={3}>
                <Box
                  bg={index === 0 ? 'gold' : index === 1 ? 'silver' : index === 2 ? '#CD7F32' : 'gray.300'}
                  color="white"
                  borderRadius="full"
                  w="24px"
                  h="24px"
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  fontSize="sm"
                  fontWeight="bold"
                >
                  {index + 1}
                </Box>
                <VStack align="start" spacing={0}>
                  <Text fontWeight="medium" fontSize="sm">
                    {user.name || user.username}
                  </Text>
                  <Text fontSize="xs" color="gray.500">
                    @{user.username}
                  </Text>
                </VStack>
              </HStack>

              <VStack align="end" spacing={0}>
                <Text fontWeight="bold" color={`${colorScheme}.600`}>
                  {user[field]}
                </Text>
                <Text fontSize="xs" color="gray.500">
                  {label}
                </Text>
              </VStack>
            </Flex>

            {index < Math.min(data.length - 1, 9) && <Divider />}
          </Box>
        )) : (
          <Text textAlign="center" color="gray.500" py={4}>
            Nenhum dado disponível
          </Text>
        )}
      </VStack>
    </Box>
  );
};

// Componente para estatísticas gerais
const StatsCard = ({ label, value, icon, colorScheme, helpText, trend }) => {
  const bgColor = useColorModeValue("white", "gray.800");

  return (
    <Stat bg={bgColor} p={4} borderRadius="lg" boxShadow="md">
      <Flex justify="space-between" align="center">
        <Box>
          <StatLabel fontSize="sm" color="gray.600">{label}</StatLabel>
          <StatNumber fontSize="2xl" color={`${colorScheme}.600`}>
            {value}
          </StatNumber>
          {helpText && (
            <StatHelpText fontSize="xs" color="gray.500">
              {helpText}
            </StatHelpText>
          )}
        </Box>
        <Icon as={icon} boxSize="32px" color={`${colorScheme}.400`} />
      </Flex>

      {trend && (
        <Progress
          value={trend}
          colorScheme={colorScheme}
          size="sm"
          mt={2}
          borderRadius="full"
        />
      )}
    </Stat>
  );
};

// Componente para alertas de alta prioridade
const HighPriorityAlert = ({ alert, handleImageClick }) => {
  const bgColor = useColorModeValue("white", "gray.800");

  const handleImageWithAuth = async (imagePath) => {
    try {
      const actualFilename = toStorageImageApiSegment(imagePath, 'infractions');
      if (!actualFilename) return;

      const token = localStorage.getItem('token');
      const response = await fetch(`/api/infractions/image/${actualFilename}`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });

      if (!response.ok) throw new Error('Erro ao buscar imagem');

      const blob = await response.blob();
      const imageUrl = URL.createObjectURL(blob);
      handleImageClick(imageUrl);
    } catch (error) {
      console.error('Erro ao carregar imagem:', error);
    }
  };

  return (
    <Box
      bg={bgColor}
      p={4}
      borderRadius="md"
      boxShadow="md"
      mb={3}
      borderLeft="4px solid"
      borderLeftColor={alert.confidence > 0.9 ? "red.400" : "orange.400"}
    >
      <Flex align="center" spacing={3}>
        {alert.image_path && (
          <Box
            boxSize="60px"
            bg="gray.100"
            borderRadius="md"
            cursor="pointer"
            onClick={() => handleImageWithAuth(alert.image_path)}
            mr={3}
            display="flex"
            alignItems="center"
            justifyContent="center"
            fontSize="xs"
            color="gray.600"
          >
            📷
          </Box>
        )}

        <Box flex="1">
          <HStack justify="space-between" mb={1}>
            <Text fontWeight="bold" fontSize="sm">
              {alert.algorithm_name}
            </Text>
            <Badge colorScheme={alert.confidence > 0.9 ? "red" : "orange"}>
              {(alert.confidence * 100).toFixed(1)}%
            </Badge>
          </HStack>

          <Text fontSize="xs" color="gray.600">
            {alert.camera_name} • {new Date(alert.detected_at).toLocaleString('pt-BR')}
          </Text>

          {alert.plate && (
            <Badge colorScheme="blue" fontSize="xs" mt={1}>
              {alert.plate}
            </Badge>
          )}
        </Box>
      </Flex>
    </Box>
  );
};

const DashboardContent = () => {
  const [userLevel, setUserLevel] = useState(null);
  const [userId, setUserId] = useState(null);
  const [username, setUsername] = useState('');
  const [greeting, setGreeting] = useState('');
  const [timeIcon, setTimeIcon] = useState(null);

  // Estados para os novos dados com valores padrão
  const [rankings, setRankings] = useState({
    confirmedRanking: [],
    analyzedRanking: [],
    batchesRanking: []
  });

  const [dashboardStats, setDashboardStats] = useState({
    generalStats: {
      infractions_24h: 0,
      confirmed_24h: 0,
      rejected_24h: 0,
      pending_total: 0,
      batches_created_24h: 0,
      batches_completed_24h: 0,
      batches_in_progress: 0,
      active_users_24h: 0,
      active_cameras_24h: 0,
      confirmation_rate_24h: 0
    },
    topCameras: []
  });

  const [cameraStats, setCameraStats] = useState({
    topCamerasMonth: [],
    bestRatioCameras: [],
    worstRatioCameras: []
  });

  const [highPriorityAlerts, setHighPriorityAlerts] = useState([]);
  const [loading, setLoading] = useState(true);

  // Modal states
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [selectedImage, setSelectedImage] = useState(null);
  const [scale, setScale] = useState(1);
  const [isDragging, setIsDragging] = useState(false);
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [dragStart, setDragStart] = useState({ x: 0, y: 0 });

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      const decoded = jwtDecode(token);
      const perms = getSessionPermissions(decoded);
      setUserLevel(perms.effectiveRole);
      setUserId(decoded.userId);
    }
  }, []);

  // Novo useEffect para inicializar quando userLevel for definido
  useEffect(() => {
    if (userLevel !== null) {
      initializeDashboard();
    }
  }, [userLevel]);

  const initializeDashboard = async () => {
    setLoading(true);
    try {
      // Sempre buscar stats primeiro
      await fetchDashboardStats();
      await fetchCameraStats();
      await fetchHighPriorityAlerts();

      // Rankings só para nível 2+
      if (userLevel >= 2) {
        fetchRankings(); // Sem await - não bloquear
      }
    } catch (error) {
      console.error('Erro ao carregar dashboard:', error);
    } finally {
      setLoading(false);
    }
  };

  const fetchRankings = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await fetch('/api/dashboard/rankings', {
        headers: { 'Authorization': `Bearer ${token}` }
      });

      if (!response.ok) {
        console.error('Erro ao buscar rankings:', response.status);
        return;
      }

      const data = await response.json();
      setRankings(data);
    } catch (error) {
      console.error('Erro ao buscar rankings:', error);
    }
  };

  const fetchCameraStats = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await fetch('/api/dashboard/camera-stats', {
        headers: { 'Authorization': `Bearer ${token}` }
      });

      if (!response.ok) {
        console.error('Erro ao buscar estatísticas de câmeras:', response.status);
        return;
      }

      const data = await response.json();
      console.log('Camera stats received:', data);
      setCameraStats({
        topCamerasMonth: Array.isArray(data.topCamerasMonth) ? data.topCamerasMonth : [],
        bestRatioCameras: Array.isArray(data.bestRatioCameras) ? data.bestRatioCameras : [],
        worstRatioCameras: Array.isArray(data.worstRatioCameras) ? data.worstRatioCameras : []
      });
    } catch (error) {
      console.error('Erro ao buscar estatísticas de câmeras:', error);
      setCameraStats({
        topCamerasMonth: [],
        bestRatioCameras: [],
        worstRatioCameras: []
      });
    }
  };

  const fetchDashboardStats = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await fetch('/api/dashboard/stats', {
        headers: { 'Authorization': `Bearer ${token}` }
      });

      if (!response.ok) {
        console.error('Erro ao buscar estatísticas:', response.status);
        return;
      }

      const data = await response.json();
      console.log('Dashboard stats received:', data);

      // Processar os dados corretamente - CORRIGIDO
      const processedData = {
        generalStats: {
          // Garantir que generalStats existe e tem valores válidos
          infractions_24h: parseInt(data.generalStats?.infractions_24h) || 0,
          confirmed_24h: parseInt(data.generalStats?.confirmed_24h) || 0,
          rejected_24h: parseInt(data.generalStats?.rejected_24h) || 0,
          pending_total: parseInt(data.generalStats?.pending_total) || 0,
          batches_created_24h: parseInt(data.generalStats?.batches_created_24h) || 0,
          batches_completed_24h: parseInt(data.generalStats?.batches_completed_24h) || 0,
          batches_in_progress: parseInt(data.generalStats?.batches_in_progress) || 0,
          active_users_24h: parseInt(data.generalStats?.active_users_24h) || 0,
          active_cameras_24h: parseInt(data.generalStats?.active_cameras_24h) || 0,
          confirmation_rate_24h: parseFloat(data.generalStats?.confirmation_rate_24h) || 0
        },
        // Garantir que sempre seja array
        topCameras: data.topCameras ?
          (Array.isArray(data.topCameras) ? data.topCameras : [data.topCameras]) : []
      };

      console.log('Processed dashboard stats:', processedData);
      setDashboardStats(processedData);
    } catch (error) {
      console.error('Erro ao buscar estatísticas:', error);
      // Definir estado padrão em caso de erro
      setDashboardStats({
        generalStats: {
          infractions_24h: 0,
          confirmed_24h: 0,
          rejected_24h: 0,
          pending_total: 0,
          batches_created_24h: 0,
          batches_completed_24h: 0,
          batches_in_progress: 0,
          active_users_24h: 0,
          active_cameras_24h: 0,
          confirmation_rate_24h: 0
        },
        topCameras: []
      });
    }
  };

  const fetchHighPriorityAlerts = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await fetch('/api/dashboard/alerts?limit=10', {
        headers: { 'Authorization': `Bearer ${token}` }
      });

      if (!response.ok) {
        console.error('Erro ao buscar alertas:', response.status);
        return;
      }

      const data = await response.json();
      console.log('High priority alerts received:', data);
      // Garantir que data seja sempre um array
      setHighPriorityAlerts(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error('Erro ao buscar alertas:', error);
      setHighPriorityAlerts([]);
    }
  };

  useEffect(() => {
    // Obter dados do usuário
    const userData = localStorage.getItem('userData');
    if (userData) {
      try {
        const parsedUserData = JSON.parse(userData);
        setUsername(parsedUserData.username || 'Usuário');
      } catch (error) {
        setUsername('Usuário');
      }
    } else {
      const token = localStorage.getItem('token');
      if (token) {
        try {
          const decoded = jwtDecode(token);
          setUsername(decoded.username || 'Usuário');
        } catch (error) {
          setUsername('Usuário');
        }
      } else {
        setUsername('Usuário');
      }
    }

    // Determinar saudação com base na hora
    const hour = new Date().getHours();

    if (hour >= 5 && hour < 12) {
      setGreeting('Bom dia');
      setTimeIcon(<SunIcon boxSize="32px" color="orange.400" />);
    } else if (hour >= 12 && hour < 18) {
      setGreeting('Boa tarde');
      setTimeIcon(<SunIcon boxSize="32px" color="orange.500" />);
    } else if (hour >= 18 && hour < 22) {
      setGreeting('Boa noite');
      setTimeIcon(<SunsetIcon boxSize="32px" color="purple.400" />);
    } else {
      setGreeting('Boa noite');
      setTimeIcon(<MoonIcon boxSize="32px" color="blue.600" />);
    }
  }, []);

  // Funções do modal de imagem
  const handleImageClick = (imageUrl) => {
    setSelectedImage(imageUrl);
    onOpen();
  };

  const handleZoomIn = () => setScale(prev => Math.min(prev + 0.5, 4));
  const handleZoomOut = () => setScale(prev => Math.max(prev - 0.5, 1));
  const handleReset = () => {
    setScale(1);
    setPosition({ x: 0, y: 0 });
  };

  const handleMouseDown = (e) => {
    setIsDragging(true);
    setDragStart({
      x: e.clientX - position.x,
      y: e.clientY - position.y
    });
  };

  const handleMouseMove = (e) => {
    if (isDragging && scale > 1) {
      setPosition({
        x: e.clientX - dragStart.x,
        y: e.clientY - dragStart.y
      });
    }
  };

  const handleMouseUp = () => setIsDragging(false);

  // Auto-refresh a cada 30 segundos
  useEffect(() => {
    const interval = setInterval(() => {
      fetchDashboardStats();
      fetchCameraStats();
      fetchHighPriorityAlerts();
      if (userLevel >= 2) {
        fetchRankings();
      }
    }, 30000);

    return () => clearInterval(interval);
  }, [userLevel]);

  if (loading) {
    return (
      <Box p={6} flex="1" minH="100vh" bg="gray.50" display="flex" alignItems="center" justifyContent="center">
        <Text>Carregando dashboard...</Text>
      </Box>
    );
  }

  // Desestruturação segura com valores padrão
  const { generalStats = {}, topCameras = [] } = dashboardStats;
  const { confirmedRanking = [], analyzedRanking = [], batchesRanking = [] } = rankings;
  const { topCamerasMonth = [], bestRatioCameras = [], worstRatioCameras = [] } = cameraStats;

  return (
    <Box p={6} flex="1" minH="100vh" bg="gray.50">
      {/* Header de Saudação */}
      <Flex
        align="center"
        bg="white"
        p={6}
        borderRadius="lg"
        boxShadow="md"
        mb={6}
        transition="all 0.3s"
        _hover={{ boxShadow: "lg" }}
      >
        <Box mr={4}>
          {timeIcon}
        </Box>
        <Box>
          <Heading size="lg">
            {greeting}, <Text as="span" color="blue.500">{username}</Text>!
          </Heading>
          <Text color="gray.600">
            Confira o desempenho da equipe e alertas de alta prioridade
          </Text>
        </Box>
      </Flex>

      {/* Estatísticas Gerais */}
      <SimpleGrid columns={{ base: 1, md: 2, lg: 4 }} spacing={6} mb={8}>
        <StatsCard
          label="Infrações (24h)"
          value={generalStats.infractions_24h || 0}
          icon={FiEye}
          colorScheme="blue"
          helpText={`${generalStats.confirmed_24h || 0} confirmadas`}
        />

        <StatsCard
          label="Taxa de Confirmação"
          value={`${generalStats.confirmation_rate_24h || 0}%`}
          icon={FiTarget}
          colorScheme="green"
          helpText="Últimas 24 horas"
          trend={generalStats.confirmation_rate_24h}
        />

        <StatsCard
          label="Lotes Concluídos"
          value={generalStats.batches_completed_24h || 0}
          icon={FiBarChart2}
          colorScheme="purple"
          helpText={`${generalStats.batches_in_progress || 0} em progresso`}
        />

        <StatsCard
          label="Usuários Ativos"
          value={generalStats.active_users_24h || 0}
          icon={FiUsers}
          colorScheme="teal"
          helpText="Últimas 24 horas"
        />
      </SimpleGrid>

      {/* Estatísticas de Câmeras */}
      <Box mb={8}>
        <Grid templateColumns={{ base: "1fr", lg: "repeat(3, 1fr)" }} gap={6}>
          {/* Top 5 Câmeras com Infrações Confirmadas (Mês) */}
          <Box bg="white" p={6} borderRadius="lg" boxShadow="md">
            <HStack mb={4} spacing={3}>
              <Icon as={FiCamera} boxSize="20px" color="blue.500" />
              <Heading size="sm" color="blue.600">
                Top 5 Câmeras (Mês)
              </Heading>
            </HStack>
            <Text fontSize="xs" color="gray.500" mb={3}>
              Infrações confirmadas no mês atual
            </Text>
            <VStack spacing={2} align="stretch" maxH="300px" overflowY="auto">
              {topCamerasMonth.length > 0 ? topCamerasMonth.map((camera, index) => (
                <Flex key={camera.camera_id || index} justify="space-between" align="center">
                  <HStack spacing={2}>
                    <Badge colorScheme="blue" fontSize="xs">{index + 1}</Badge>
                    <Text fontSize="sm" fontWeight="medium" noOfLines={1}>
                      {camera.camera_name}
                    </Text>
                  </HStack>
                  <Badge colorScheme="green">
                    {camera.confirmed_count}
                  </Badge>
                </Flex>
              )) : (
                <Text textAlign="center" color="gray.500" py={4}>
                  Nenhum dado disponível
                </Text>
              )}
            </VStack>
          </Box>

          {/* Top 3 Câmeras - Melhor Proporção */}
          <Box bg="white" p={6} borderRadius="lg" boxShadow="md">
            <HStack mb={4} spacing={3}>
              <Icon as={FiAward} boxSize="20px" color="green.500" />
              <Heading size="sm" color="green.600">
                Melhor Proporção
              </Heading>
            </HStack>
            <Text fontSize="xs" color="gray.500" mb={3}>
              Confirmadas vs Rejeitadas (últimos 30 dias)
            </Text>
            <VStack spacing={3} align="stretch">
              {bestRatioCameras.length > 0 ? bestRatioCameras.map((camera, index) => (
                <Box key={camera.camera_id || index}>
                  <Flex justify="space-between" align="center" mb={1}>
                    <HStack spacing={2}>
                      <Badge colorScheme="green" fontSize="xs">{index + 1}</Badge>
                      <Text fontSize="sm" fontWeight="medium" noOfLines={1}>
                        {camera.camera_name}
                      </Text>
                    </HStack>
                    <Badge colorScheme="green" fontSize="lg">
                      {camera.confirmation_rate}%
                    </Badge>
                  </Flex>
                  <Text fontSize="xs" color="gray.500">
                    {camera.confirmed_count} confirmadas / {camera.rejected_count} rejeitadas
                  </Text>
                </Box>
              )) : (
                <Text textAlign="center" color="gray.500" py={4}>
                  Nenhum dado disponível
                </Text>
              )}
            </VStack>
          </Box>

          {/* Top 3 Câmeras - Pior Proporção */}
          <Box bg="white" p={6} borderRadius="lg" boxShadow="md">
            <HStack mb={4} spacing={3}>
              <Icon as={FiAlertTriangle} boxSize="20px" color="orange.500" />
              <Heading size="sm" color="orange.600">
                Menor Proporção
              </Heading>
            </HStack>
            <Text fontSize="xs" color="gray.500" mb={3}>
              Confirmadas vs Rejeitadas (últimos 30 dias)
            </Text>
            <VStack spacing={3} align="stretch">
              {worstRatioCameras.length > 0 ? worstRatioCameras.map((camera, index) => (
                <Box key={camera.camera_id || index}>
                  <Flex justify="space-between" align="center" mb={1}>
                    <HStack spacing={2}>
                      <Badge colorScheme="orange" fontSize="xs">{index + 1}</Badge>
                      <Text fontSize="sm" fontWeight="medium" noOfLines={1}>
                        {camera.camera_name}
                      </Text>
                    </HStack>
                    <Badge colorScheme="orange" fontSize="lg">
                      {camera.confirmation_rate}%
                    </Badge>
                  </Flex>
                  <Text fontSize="xs" color="gray.500">
                    {camera.confirmed_count} confirmadas / {camera.rejected_count} rejeitadas
                  </Text>
                </Box>
              )) : (
                <Text textAlign="center" color="gray.500" py={4}>
                  Nenhum dado disponível
                </Text>
              )}
            </VStack>
          </Box>
        </Grid>
      </Box>

      {/* Rankings - apenas para usuários de nível 2 ou superior */}
      {userLevel >= 2 && (
        <Box mb={8}>
          <Grid templateColumns={{ base: "1fr", lg: "repeat(3, 1fr)" }} gap={6}>
            <RankingCard
              title="Mais Infrações Confirmadas"
              data={confirmedRanking}
              icon={FiTrendingUp}
              colorScheme="green"
              field="confirmed_count"
              label="confirmadas"
            />

            <RankingCard
              title="Mais Infrações Analisadas"
              data={analyzedRanking}
              icon={FiActivity}
              colorScheme="blue"
              field="analyzed_count"
              label="analisadas"
            />

            <RankingCard
              title="Mais Lotes Concluídos"
              data={batchesRanking}
              icon={FiBarChart2}
              colorScheme="purple"
              field="completed_batches"
              label="lotes"
            />
          </Grid>
        </Box>
      )}

      {/* Seção de Alertas e Performance */}
      <Grid templateColumns={{ base: "1fr", lg: "2fr 1fr" }} gap={6} mb={8}>
        {/* Alertas de Alta Prioridade */}
        <Box bg="white" p={6} borderRadius="lg" boxShadow="md">
          <HStack mb={4} spacing={3}>
            <Icon as={FiAlertTriangle} boxSize="24px" color="red.500" />
            <Heading size="md" color="red.600">
              Alertas de Alta Prioridade
            </Heading>
          </HStack>

          <VStack spacing={3} align="stretch" maxH="400px" overflowY="auto">
            {highPriorityAlerts.length > 0 ? (
              highPriorityAlerts.map(alert => (
                <HighPriorityAlert
                  key={alert.id}
                  alert={alert}
                  handleImageClick={handleImageClick}
                />
              ))
            ) : (
              <Text textAlign="center" color="gray.500" py={8}>
                Nenhum alerta de alta prioridade
              </Text>
            )}
          </VStack>
        </Box>

        {/* Top Câmeras (24h) */}
        <Box bg="white" p={6} borderRadius="lg" boxShadow="md">
          <HStack mb={4} spacing={3}>
            <Icon as={FiCamera} boxSize="20px" color="blue.500" />
            <Heading size="sm" color="blue.600">
              Top Câmeras (24h)
            </Heading>
          </HStack>
          <Text fontSize="xs" color="gray.500" mb={3}>
            Detecções nas últimas 24 horas
          </Text>
          <VStack spacing={2} align="stretch">
            {topCameras && topCameras.length > 0 ? topCameras.map((camera, index) => (
              <Flex key={camera.camera_id || index} justify="space-between" align="center">
                <Text fontSize="sm" fontWeight="medium" noOfLines={2}>
                  {camera.camera_name}
                </Text>
                <Badge colorScheme="blue" ml={2}>
                  {camera.detection_count}
                </Badge>
              </Flex>
            )) : (
              <Text textAlign="center" color="gray.500" py={4}>
                Nenhum dado disponível
              </Text>
            )}
          </VStack>
        </Box>
      </Grid>

      {/* Modal de Imagem */}
      <Modal isOpen={isOpen} onClose={onClose} size="xl">
        <ModalOverlay />
        <ModalContent maxW="90vw">
          <ModalHeader>
            Visualização da Imagem
            <Flex gap={2} mt={2}>
              <Button size="sm" onClick={handleZoomIn}>Zoom +</Button>
              <Button size="sm" onClick={handleZoomOut}>Zoom -</Button>
              <Button size="sm" onClick={handleReset}>Reset</Button>
            </Flex>
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody pb={6}>
            <Box
              position="relative"
              overflow="hidden"
              cursor={isDragging ? "grabbing" : "grab"}
              onMouseDown={handleMouseDown}
              onMouseMove={handleMouseMove}
              onMouseUp={handleMouseUp}
              onMouseLeave={handleMouseUp}
            >
              {selectedImage && (
                <Image
                  src={selectedImage}
                  alt="Imagem ampliada"
                  w="100%"
                  maxH="70vh"
                  objectFit="contain"
                  transform={`scale(${scale}) translate(${position.x / scale}px, ${position.y / scale}px)`}
                  transition="transform 0.1s"
                  draggable="false"
                />
              )}
            </Box>
          </ModalBody>
        </ModalContent>
      </Modal>
    </Box>
  );
};

export default DashboardContent;